import { useTranslation } from 'react-i18next';
import { doTrack } from '@/track/track.service';
import { Modal } from '@seeqdev/qomponents';

interface GlobalScopeAccessConfirmModalProps {
  onCancel: () => void;
  onConfirm: () => void;
}

export const GlobalScopeAccessConfirmModal = ({ onCancel, onConfirm }: GlobalScopeAccessConfirmModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={true}
      testId="globalScopeAccessConfirmModal"
      title={t('ITEM_ACL.GLOBAL_SCOPE_ACCESS.HEADER')}
      onClose={() => {
        doTrack('Access Control Global Confirmation', 'cancel');
        onCancel();
      }}
      submitButtonLabel={t('ITEM_ACL.GLOBAL_SCOPE_ACCESS.CONFIRM')}
      onSubmit={() => {
        doTrack('Access Control Global Confirmation', 'confirm');
        onConfirm();
      }}
      size="lg"
      cancelButtonLabel={t('CANCEL')}>
      <div>
        {t('ITEM_ACL.GLOBAL_SCOPE_ACCESS.MESSAGE')}
        <div className="sq-text-warning text-bolder mt10" data-testid="globalScopeAccessWarning">
          {t('ITEM_ACL.GLOBAL_SCOPE_ACCESS.WARNING')}
        </div>
      </div>
    </Modal>
  );
};
